import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faEdit, faFileAlt, faEye, faFile } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import mascaras from '../../../../helpers/mascaras';
import { abrirPDF } from 'helpers/abrirPDF';
export default function FichaDestinoContainer({ destino, editDestino, editEndereco }) {

    return (
        <div style={{ color: "#666" }}>
            <h5 className="bg-gradient bg-primary p-1 rounded-3 d-flex align-items-center justify-content-between" style={{ color: "#fff" }}><span><FontAwesomeIcon className='me-3' icon={faPencilAlt} />Identificação do destino </span>{editDestino && <button onClick={editDestino} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }}><FontAwesomeIcon icon={faEdit} /></button>}</h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">CNPJ: </span>{destino.cnpj === "" ? "Não informado" : mascaras.cnpjMask(destino.cnpj)}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Inscrição: </span>{destino.inscricao === "" ? "Não informado" : destino.inscricao}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Responsável: </span>{destino.responsavel === "" ? "Não informado" : destino.responsavel}</p>

                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">E-mail: </span>{destino.email === "" ? "Não informado" : destino.email}</p>

                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Fantasia: </span>{destino.fantasia === "" ? "Não informado" : destino.fantasia}</p>

                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Razão social: </span>{destino.razao === "" ? "Não informado" : destino.razao}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Fone: </span>{destino.fone === "" ? "Não informado" : mascaras.celularMask(destino.fone)}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Data averbação: </span>{moment(destino.dataAverbacao).format("DD/MM/YYYY") !== "Data inválida" ? moment(destino.dataAverbacao).format("DD/MM/YYYY") : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Tipo de destino: </span>{destino.tbTipoDestino_descricao === "" || destino.tbTipoDestino_descricao == null ? "Não informado" : destino.tbTipoDestino_descricao}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Tipos de resíduo: </span>{destino.tiposResiduos.length === 0 ? "Não informado" : destino.tiposResiduos.map((value, index, array) => `${value.label}${index !== array.length - 1 ? ", " : ""}`)}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Orgão de expedição da licença: </span>{destino.orgaoExpLicencaOperacao === "" ? "Não informado" : destino.orgaoExpLicencaOperacao}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Validade da licença: </span>{moment(destino.validadeLicencaOperacao).format("DD/MM/YYYY") !== "Data inválida" ? moment(destino.validadeLicencaOperacao).format("DD/MM/YYYY") : "Não informado"}</p>
                </Col>
            </Row>
            <Row>


                <Col md="12" lg="4">
                    <p><span className="fw-bold">Protocolo/Averbação: </span>{destino.protocolo_Averbacao === "" ? "Não informado" : destino.protocolo_Averbacao}</p>
                </Col>
                <Col md="12" lg="8">
                    <p><span className="fw-bold">Número da licença de operação: </span>{destino.numeroLicencaOperacao === "" ? "Não informado" : destino.numeroLicencaOperacao}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Status: </span>{destino.status === "" ? "Não informado" : destino.status}</p>
                </Col>
            </Row>
            <h5 className="bg-gradient bg-primary p-1 rounded-3 d-flex align-items-center justify-content-between" style={{ color: "#fff" }}><span><FontAwesomeIcon className='me-3' icon={faMapMarkerAlt} />Endereço </span>{editEndereco && <button onClick={editEndereco} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }}><FontAwesomeIcon icon={faEdit} /></button>}</h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">CEP: </span>{destino.cep === "" ? "Não informado" : mascaras.cepMask(destino.cep)}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">UF: </span>{destino.uf === "" ? "Não informado" : destino.uf}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Cidade: </span>{destino.cidade === "" ? "Não informado" : destino.cidade}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Bairro: </span>{destino.bairro === "" ? "Não informado" : destino.bairro}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Logradouro: </span>{destino.logradouro === "" ? "Não informado" : destino.logradouro}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Número: </span>{destino.numero === "" ? "Não informado" : destino.numero}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Complemento: </span>{destino.complemento === "" ? "Não informado" : destino.complemento}</p>
                </Col>

            </Row>

            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
            </h5>
            <Row>
                {destino?.documentos.map((documento, index) => (
                    <Col lg={3} key={index} className="mb-3">
                        <div className="card shadow h-100">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="d-flex flex-column align-items-center">
                                    <label htmlFor={`file-upload-${index}`} className="mb-3">
                                        <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                                    </label>
                                </div>

                                <div className="mb-3">
                                    <strong>{documento.identificacao || "Documento"}</strong>
                                </div>

                                <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                                    if (documento.arquivo.includes(".pdf"))
                                        window.open(documento.arquivo, "_blank")
                                    else
                                        abrirPDF(documento.arquivo);
                                }}>
                                    <FontAwesomeIcon icon={faEye} /> Visualizar
                                </button>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    )
}
